var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 94,
    viewBox: "0 0 92 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic/arrow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 39898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 3151",
    d: "M42.1893 77.742L51.7591 67.3173L75.0738 91.8354L89.5586 76.9592L65.2807 53.552L75.0738 44.0749L29.5314 31.8086L42.1893 77.742Z",
    fill: "white",
    fillOpacity: 0.5,
    stroke: "white",
    strokeWidth: 3.78333,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3152",
    d: "M77.5527 13.0076L67.8191 22.9645M56.538 2L53.2952 15.7878M33.0214 3.10081L36.8916 16.6423M13.2075 15.2093L23.0144 25.2162M2.80019 33.2218L16.81 37.1245M1.99961 56.8382L15.9094 53.3357M12.507 77.7528L23.0144 67.7458",
    stroke: "white",
    strokeWidth: 3.78333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9154abeab33056907c3d5fbcfd8e2781.svg";
export { ForwardRef as ReactComponent };